"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Grid_meta_1 = require("../Grid.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('section', Grid_meta_1.GRID_CATEGORY_KEY, Grid_meta_1.GRID_COMPONENT_KEY, ['row']);